"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _RegistrationDetails = _interopRequireDefault(require("./RegistrationDetails"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The User model module.
 * @module model/User
 * @version 3.0
 */
var User = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>User</code>.
   * @alias module:model/User
   */
  function User() {
    _classCallCheck(this, User);
    User.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(User, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>User</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/User} obj Optional instance to populate.
     * @return {module:model/User} The populated <code>User</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new User();
        if (data.hasOwnProperty('userId')) {
          obj['userId'] = _ApiClient["default"].convertToType(data['userId'], 'Number');
        }
        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient["default"].convertToType(data['category'], 'String');
        }
        if (data.hasOwnProperty('userName')) {
          obj['userName'] = _ApiClient["default"].convertToType(data['userName'], 'String');
        }
        if (data.hasOwnProperty('temporary')) {
          obj['temporary'] = _ApiClient["default"].convertToType(data['temporary'], 'Boolean');
        }
        if (data.hasOwnProperty('locked')) {
          obj['locked'] = _ApiClient["default"].convertToType(data['locked'], 'Boolean');
        }
        if (data.hasOwnProperty('tryCount')) {
          obj['tryCount'] = _ApiClient["default"].convertToType(data['tryCount'], 'Number');
        }
        if (data.hasOwnProperty('lastLoginDate')) {
          obj['lastLoginDate'] = _ApiClient["default"].convertToType(data['lastLoginDate'], 'Date');
        }
        if (data.hasOwnProperty('firstLogin')) {
          obj['firstLogin'] = _ApiClient["default"].convertToType(data['firstLogin'], 'Boolean');
        }
        if (data.hasOwnProperty('hasAuthCode')) {
          obj['hasAuthCode'] = _ApiClient["default"].convertToType(data['hasAuthCode'], 'Boolean');
        }
        if (data.hasOwnProperty('theme')) {
          obj['theme'] = _ApiClient["default"].convertToType(data['theme'], 'String');
        }
        if (data.hasOwnProperty('language')) {
          obj['language'] = _ApiClient["default"].convertToType(data['language'], 'String');
        }
        if (data.hasOwnProperty('regCompleted')) {
          obj['regCompleted'] = _ApiClient["default"].convertToType(data['regCompleted'], 'Boolean');
        }
        if (data.hasOwnProperty('regCompletedDate')) {
          obj['regCompletedDate'] = _ApiClient["default"].convertToType(data['regCompletedDate'], 'Date');
        }
        if (data.hasOwnProperty('rootGuest')) {
          obj['rootGuest'] = _ApiClient["default"].convertToType(data['rootGuest'], 'Boolean');
        }
        if (data.hasOwnProperty('guest')) {
          obj['guest'] = _ApiClient["default"].convertToType(data['guest'], 'Boolean');
        }
        if (data.hasOwnProperty('capturedRegistrationDetails')) {
          obj['capturedRegistrationDetails'] = _RegistrationDetails["default"].constructFromObject(data['capturedRegistrationDetails']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>User</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>User</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
        throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
      }
      // ensure the json data is a string
      if (data['userName'] && !(typeof data['userName'] === 'string' || data['userName'] instanceof String)) {
        throw new Error("Expected the field `userName` to be a primitive type in the JSON string but got " + data['userName']);
      }
      // ensure the json data is a string
      if (data['theme'] && !(typeof data['theme'] === 'string' || data['theme'] instanceof String)) {
        throw new Error("Expected the field `theme` to be a primitive type in the JSON string but got " + data['theme']);
      }
      // ensure the json data is a string
      if (data['language'] && !(typeof data['language'] === 'string' || data['language'] instanceof String)) {
        throw new Error("Expected the field `language` to be a primitive type in the JSON string but got " + data['language']);
      }
      // validate the optional field `capturedRegistrationDetails`
      if (data['capturedRegistrationDetails']) {
        // data not null
        _RegistrationDetails["default"].validateJSON(data['capturedRegistrationDetails']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} userId
 */
User.prototype['userId'] = undefined;

/**
 * @member {String} category
 */
User.prototype['category'] = undefined;

/**
 * @member {String} userName
 */
User.prototype['userName'] = undefined;

/**
 * @member {Boolean} temporary
 */
User.prototype['temporary'] = undefined;

/**
 * @member {Boolean} locked
 */
User.prototype['locked'] = undefined;

/**
 * @member {Number} tryCount
 */
User.prototype['tryCount'] = undefined;

/**
 * @member {Date} lastLoginDate
 */
User.prototype['lastLoginDate'] = undefined;

/**
 * @member {Boolean} firstLogin
 */
User.prototype['firstLogin'] = undefined;

/**
 * @member {Boolean} hasAuthCode
 */
User.prototype['hasAuthCode'] = undefined;

/**
 * @member {String} theme
 */
User.prototype['theme'] = undefined;

/**
 * @member {String} language
 */
User.prototype['language'] = undefined;

/**
 * @member {Boolean} regCompleted
 */
User.prototype['regCompleted'] = undefined;

/**
 * @member {Date} regCompletedDate
 */
User.prototype['regCompletedDate'] = undefined;

/**
 * @member {Boolean} rootGuest
 */
User.prototype['rootGuest'] = undefined;

/**
 * @member {Boolean} guest
 */
User.prototype['guest'] = undefined;

/**
 * @member {module:model/RegistrationDetails} capturedRegistrationDetails
 */
User.prototype['capturedRegistrationDetails'] = undefined;
var _default = exports["default"] = User;